import { findNearestExchangeRate } from './currency.js';
import { toTwoDecimalFloat } from './textparse.js';
import moment from 'moment';

import { getGeneralLedgerData } from './generalledger.js';

export function getsummary(accountledgers, currencies, exchangerates, selectedcurrencyid) {
    let currencysymbol = currencies.find((currency) => currency.id === selectedcurrencyid)?.symbol;
    let totalDebit = 0;
    let totalCredit = 0;

    for (let i = 0; i < accountledgers.length; i++) {
        const item = accountledgers[i];

        if (item.currencyid !== selectedcurrencyid) {
            const rate = findNearestExchangeRate(exchangerates, item.ts, item.currencyid, selectedcurrencyid).exchangerate;
            totalDebit += Number(item.debit) * rate || 0;
            totalCredit += Number(item.credit) * rate || 0;
        }
        else {
            totalDebit += Number(item.debit) || 0;
            totalCredit += Number(item.credit) || 0;
        }
    }
    return {
        currency: currencysymbol,
        totaldebit: totalDebit,
        totalcredit: totalCredit,
        total: totalCredit - totalDebit
    }
}

export function getClientAccountSOA(context) {
    const {
        accountid,
        currencies,
        exchangerates,
        fromts,
        tots,
        selectedsubaccountid,
        selectedcurrencyid,
    } = context;

    const statementData = { data: [], summary: {} };
    let data = [];

    const selectedcurrencysymbol = currencies.find((currency) => currency.id === selectedcurrencyid)?.symbol;

    const generalledgerdata = getGeneralLedgerData(context);
    let filtereddata = generalledgerdata
        .filter(data => data.accounttype == 'clients')
        .filter(data => data.accountid == accountid)
        .filter(data => data.ts >= fromts && data.ts <= tots)
        .filter(data => !selectedsubaccountid || data.subaccountid == selectedsubaccountid)

    let balance = 0;
    filtereddata.forEach((entry) => {
        const date = moment.unix(entry.ts).format('D/MMM/YYYY')
        let debit = parseFloat(entry.debit) || 0;
        let credit = parseFloat(entry.credit) || 0;

        if (entry.currencyid !== selectedcurrencyid) {
            const NearestExchangeRate = findNearestExchangeRate(exchangerates, entry.ts, entry.currencyid, selectedcurrencyid);
            const exchangerate = NearestExchangeRate.exchangerate;

            debit = debit * exchangerate;
            credit = credit * exchangerate;
        }

        balance = balance - debit + credit;

        data.push({
            id: entry.id,
            type: entry.type,
            date: date,
            name: entry.name,
            debit: debit,
            debitcurrency: selectedcurrencysymbol,
            credit: credit,
            creditcurrency: selectedcurrencysymbol,
            balance: balance,
            balancecurrency: selectedcurrencysymbol,
        })
    });

    let summary = { currency: '', totalcredit: 0, totaldebit: 0, total: 0 };
    summary = getsummary(data, currencies, exchangerates, selectedcurrencyid)

    statementData.data = data;
    statementData.summary = summary;

    return statementData;
}

export function getSupplierAccountSOA(context) {
    const {
        accountid,
        currencies,
        exchangerates,
        fromts,
        tots,
        selectedsubaccountid,
        selectedcurrencyid,
    } = context;

    const statementData = { data: [], summary: {} };
    let data = [];

    const selectedcurrencysymbol = currencies.find((currency) => currency.id === selectedcurrencyid)?.symbol;

    const generalledgerdata = getGeneralLedgerData(context);
    let filtereddata = generalledgerdata
        .filter(data => data.accounttype == 'suppliers')
        .filter(data => data.accountid == accountid)
        .filter(data => data.ts >= fromts && data.ts <= tots)

    let balance = 0;
    filtereddata.forEach((entry) => {
        const date = moment.unix(entry.ts).format('D/MMM/YYYY')
        let debit = parseFloat(entry.debit) || 0;
        let credit = parseFloat(entry.credit) || 0;

        if (entry.currencyid !== selectedcurrencyid) {
            const NearestExchangeRate = findNearestExchangeRate(exchangerates, entry.ts, entry.currencyid, selectedcurrencyid);
            const exchangerate = NearestExchangeRate.exchangerate;

            debit = debit * exchangerate;
            credit = credit * exchangerate;
        }

        balance = balance - debit + credit;

        data.push({
            id: entry.id,
            type: entry.type,
            date: date,
            name: entry.name,
            debit: debit,
            debitcurrency: selectedcurrencysymbol,
            credit: credit,
            creditcurrency: selectedcurrencysymbol,
            balance: balance,
            balancecurrency: selectedcurrencysymbol,
        })
    });

    let summary = { currency: '', totalcredit: 0, totaldebit: 0, total: 0 };
    summary = getsummary(data, currencies, exchangerates, selectedcurrencyid)

    statementData.data = data;
    statementData.summary = summary;

    return statementData;
}

export function getIncomeAccountSOA(context) {
    const {
        accountid,
        currencies,
        exchangerates,
        fromts,
        tots,
        selectedsubaccountid,
        selectedcurrencyid,
    } = context;

    const statementData = { data: [], summary: {} };
    let data = [];

    const selectedcurrencysymbol = currencies.find((currency) => currency.id === selectedcurrencyid)?.symbol;

    const generalledgerdata = getGeneralLedgerData(context);
    let filtereddata = generalledgerdata
        .filter(data => data.accounttype == 'incomeaccounts')
        .filter(data => data.accountid == accountid)
        .filter(data => data.ts >= fromts && data.ts <= tots)

    let balance = 0;
    filtereddata.forEach((entry) => {
        const date = moment.unix(entry.ts).format('D/MMM/YYYY')
        let debit = parseFloat(entry.debit) || 0;
        let credit = parseFloat(entry.credit) || 0;

        if (entry.currencyid !== selectedcurrencyid) {
            const NearestExchangeRate = findNearestExchangeRate(exchangerates, entry.ts, entry.currencyid, selectedcurrencyid);
            const exchangerate = NearestExchangeRate.exchangerate;

            debit = debit * exchangerate;
            credit = credit * exchangerate;
        }

        balance = balance - debit + credit

        data.push({
            id: entry.id,
            type: entry.type,
            date: date,
            name: entry.name,
            debit: debit,
            debitcurrency: selectedcurrencysymbol,
            credit: credit,
            creditcurrency: selectedcurrencysymbol,
            balance: balance,
            balancecurrency: selectedcurrencysymbol,
        })
    });

    let summary = { currency: '', totalcredit: 0, totaldebit: 0, total: 0 };
    summary = getsummary(data, currencies, exchangerates, selectedcurrencyid)

    statementData.data = data;
    statementData.summary = summary;

    return statementData;
}

export function getExpenseAccountSOA(context) {
    const {
        accountid,
        currencies,
        exchangerates,
        fromts,
        tots,
        selectedsubaccountid,
        selectedcurrencyid,
    } = context;

    const statementData = { data: [], summary: {} };
    let data = [];

    const selectedcurrencysymbol = currencies.find((currency) => currency.id === selectedcurrencyid)?.symbol;

    const generalledgerdata = getGeneralLedgerData(context);
    let filtereddata = generalledgerdata
        .filter(data => data.accounttype == 'expenseaccounts')
        .filter(data => data.accountid == accountid)
        .filter(data => data.ts >= fromts && data.ts <= tots)

    let balance = 0;
    filtereddata.forEach((entry) => {
        const date = moment.unix(entry.ts).format('D/MMM/YYYY')
        let debit = parseFloat(entry.debit) || 0;
        let credit = parseFloat(entry.credit) || 0;

        if (entry.currencyid !== selectedcurrencyid) {
            const NearestExchangeRate = findNearestExchangeRate(exchangerates, entry.ts, entry.currencyid, selectedcurrencyid);
            const exchangerate = NearestExchangeRate.exchangerate;

            debit = debit * exchangerate;
            credit = credit * exchangerate;
        }

        balance = balance - debit + credit

        data.push({
            id: entry.id,
            type: entry.type,
            date: date,
            name: entry.name,
            debit: debit,
            debitcurrency: selectedcurrencysymbol,
            credit: credit,
            creditcurrency: selectedcurrencysymbol,
            balance: balance,
            balancecurrency: selectedcurrencysymbol,
        })
    });

    let summary = { currency: '', totalcredit: 0, totaldebit: 0, total: 0 };
    summary = getsummary(data, currencies, exchangerates, selectedcurrencyid)

    statementData.data = data;
    statementData.summary = summary;

    return statementData;
}

export function getLiabilityAccountSOA(context) {
    const {
        accountid,
        currencies,
        exchangerates,
        fromts,
        tots,
        selectedsubaccountid,
        selectedcurrencyid,
    } = context;

    const statementData = { data: [], summary: {} };
    let data = [];

    const selectedcurrencysymbol = currencies.find((currency) => currency.id === selectedcurrencyid)?.symbol;

    const generalledgerdata = getGeneralLedgerData(context);
    let filtereddata = generalledgerdata
        .filter(data => data.accounttype == 'liabilityaccounts')
        .filter(data => data.accountid == accountid)
        .filter(data => data.ts >= fromts && data.ts <= tots)

    let balance = 0;
    filtereddata.forEach((entry) => {
        const date = moment.unix(entry.ts).format('D/MMM/YYYY')
        let debit = parseFloat(entry.debit) || 0;
        let credit = parseFloat(entry.credit) || 0;

        if (entry.currencyid !== selectedcurrencyid) {
            const NearestExchangeRate = findNearestExchangeRate(exchangerates, entry.ts, entry.currencyid, selectedcurrencyid);
            const exchangerate = NearestExchangeRate.exchangerate;

            debit = debit * exchangerate;
            credit = credit * exchangerate;
        }

        balance = balance - debit + credit

        data.push({
            id: entry.id,
            type: entry.type,
            date: date,
            name: entry.name,
            debit: debit,
            debitcurrency: selectedcurrencysymbol,
            credit: credit,
            creditcurrency: selectedcurrencysymbol,
            balance: balance,
            balancecurrency: selectedcurrencysymbol,
        })
    });

    let summary = { currency: '', totalcredit: 0, totaldebit: 0, total: 0 };
    summary = getsummary(data, currencies, exchangerates, selectedcurrencyid)

    statementData.data = data;
    statementData.summary = summary;

    return statementData;
}

export function getCashAccountSOA(context) { //20240524
    const {
        accountid,
        reconciliations,
        currencies,
        exchangerates,
        fromts,
        tots,
        selectedsubaccountid,
        selectedcurrencyid,
    } = context;

    const statementData = { data: [], summary: {} };
    let data = [];

    const currency = currencies.find((currency) => currency.id === selectedcurrencyid)?.symbol || '';

    const generalledgerdata = getGeneralLedgerData(context);
    let filtereddata = generalledgerdata
        .filter(data => data.accounttype == 'cashaccounts')
        .filter(data => data.accountid == accountid)
        .filter(data => data.ts >= fromts && data.ts <= tots)

    let balance = 0;
    filtereddata.forEach((entry) => {
        const date = moment.unix(entry.ts).format('D/MMM/YYYY')

        let debit = parseFloat(entry.debit) || 0;
        let credit = parseFloat(entry.credit) || 0;

        if (entry.currencyid !== selectedcurrencyid) {
            const NearestExchangeRate = findNearestExchangeRate(exchangerates, entry.ts, entry.currencyid, selectedcurrencyid);
            const exchangerate = NearestExchangeRate.exchangerate;

            debit = debit * exchangerate;
            credit = credit * exchangerate;
        }

        balance = balance - debit + credit;

        data.push({
            id: entry.id,
            type: entry.type,
            date: date,
            name: entry.name,
            from: entry.from,
            debit: debit,
            debitcurrency: currency,
            credit: credit,
            creditcurrency: currency,
            balance: balance,
            balancecurrency: currency,
        })
    });

    const relevantReconciliations = reconciliations.filter(reconciliation => reconciliation.cashaccountid === accountid);
    relevantReconciliations.sort((a, b) => a.ts - b.ts);

    let reconciled = true;
    data.forEach((entry) => {
        let matchingReconciliation = relevantReconciliations.find((reconciliation) => {
            return moment.unix(entry.ts).startOf('day').isSame(moment.unix(reconciliation.ts).startOf('day'));
        });

        if (matchingReconciliation) {
            if (parseFloat(entry.balanceamount) !== parseFloat(matchingReconciliation.balance)) {
                let foundMatchingBalance = data.some((otherEntry) => {
                    return moment.unix(otherEntry.ts).startOf('day').isSame(moment.unix(entry.ts).startOf('day')) &&
                        parseFloat(otherEntry.balanceamount) === parseFloat(matchingReconciliation.balance);
                });

                if (!foundMatchingBalance) {
                    reconciled = false;
                }
            }
        }

        if (reconciled) {
            entry.reconciliationstatus = "Reconciled";
            if (matchingReconciliation) entry.reconciliationstatus = entry.reconciliationstatus + ' ' + matchingReconciliation.balance + entry.creditcurrency;
        }
        if (!reconciled) {
            entry.reconciliationstatus = "Not Reconciled";
            if (matchingReconciliation) entry.reconciliationstatus = entry.reconciliationstatus + ' ' + matchingReconciliation.balance + entry.creditcurrency;
        }
    });

    let summary = { currency: '', totalcredit: 0, totaldebit: 0, total: 0 };
    summary = getsummary(data, currencies, exchangerates, selectedcurrencyid)

    statementData.data = data;
    statementData.summary = summary;

    return statementData;
}

export function getReceiptsSOA(context) {
    const {
        accountid,
        clients,
        transactions,
        cashaccounts,
        subaccounts,
        exchangerates,
        currencies,
        fromts,
        tots,
        cashaccount,
        subaccountid,
        basecurrency,
    } = context;

    const statementData = { data: [], summary: {} };
    let data = [];
    const summary = { currency: '', totaldebit: 0, totalcredit: 0, total: 0 };

    const generalledgerdata = getGeneralLedgerData(context);
    data = generalledgerdata
        .filter(data => data.accounttype == 'clients')
        .filter(data => data.accountid == accountid)
        .filter(data => data.ts >= fromts && data.ts <= tots)

    const currency = currencies.find((currency) => currency.id === basecurrency)?.symbol || '';
    summary.currency = currency;

    let totalReceipts = 0;

    summary.closingbalance = totalReceipts;

    let balance = 0;
    data.forEach((entry) => {
        entry.balancecurrency = entry.debitcurrency || entry.creditcurrency;
        entry.balanceamount = toTwoDecimalFloat(balance + entry.debitamount - entry.creditamount);
        balance = entry.balanceamount;
    });

    statementData.data = data;
    statementData.summary = summary;

    return statementData;
}

export function getItemsSOA(context) {
    const {
        accountid,
        purchaseinvoices,
        salesinvoices,
        productionorders,
        fromts,
        tots,
        subaccountid
    } = context;

    const statementData = { data: [], summary: {} };
    let data = [];
    const summary = { currency: '', totaldebit: 0, totalcredit: 0, total: 0 };

    purchaseinvoices
        .filter(tx => tx.ts >= fromts && tx.ts <= tots)
        .forEach(invoice => {
            if (
                (!subaccountid || invoice.subaccountid === subaccountid) &&
                invoice.items?.some(i => i.accountid === accountid)
            ) {
                invoice.items.forEach(i => {
                    if (i.accountid === accountid) {
                        const quantity = parseFloat(i.itemquantity);
                        let debit = quantity < 0 ? Math.abs(quantity) : 0;
                        let credit = quantity > 0 ? quantity : 0;
                        const date = moment.unix(invoice.ts).format('D/MMM/YYYY');
                        data.push({
                            ts: invoice.ts,
                            id: invoice.id,
                            date: date,
                            type: 'PI',
                            name: i.name || invoice.name,
                            debitamount: debit,
                            creditamount: credit
                        });
                        summary.totaldebit += debit;
                        summary.totalcredit += credit;
                    }
                });
            }
        });

    salesinvoices
        .filter(tx => tx.ts >= fromts && tx.ts <= tots)
        .forEach(invoice => {
            if (
                (!subaccountid || invoice.subaccountid === subaccountid) &&
                invoice.items?.some(i => i.accountid === accountid)
            ) {
                invoice.items.forEach(i => {
                    const quantity = parseFloat(i.itemquantity);
                    let debit = quantity > 0 ? quantity : 0;
                    let credit = quantity < 0 ? Math.abs(quantity) : 0;
                    const date = moment.unix(invoice.ts).format('D/MMM/YYYY');
                    if (i.accountid === accountid) {
                        data.push({
                            ts: invoice.ts,
                            id: invoice.id,
                            date: date,
                            type: 'SI',
                            name: i.name ? i.name : invoice.name,
                            debitamount: debit,
                            creditamount: credit
                        });
                        summary.totaldebit += debit;
                        summary.totalcredit += credit;
                    }
                });
            }
        });

    productionorders.forEach(order => {
        order.items.forEach(orderitem => {
            if (orderitem.accountid == accountid) {
                salesinvoices.forEach(invoice => {
                    invoice.items.forEach(item => {
                        if (item.accountid === order.itemid) {
                            const soldQty = parseFloat(item.itemquantity || 0);
                            const usedQty = parseFloat(orderitem.itemquantity || 0) * soldQty;
                            const date = moment.unix(invoice.ts).format('D/MMM/YYYY');
                            data.push({
                                ts: invoice.ts,
                                id: invoice.id,
                                date: date,
                                type: 'SI-PO',
                                name: orderitem.name || order.itemid,
                                debitamount: usedQty,
                                creditamount: 0
                            });
                            summary.totaldebit += usedQty;
                        }
                    });
                });
            }
        });
    });

    data.sort((a, b) => a.ts - b.ts);

    let balance = 0;
    data.forEach((entry) => {
        entry.balanceamount = toTwoDecimalFloat(balance + entry.creditamount - entry.debitamount);
        balance = entry.balanceamount;
    });
    summary.closingbalance = summary.totalcredit - summary.totaldebit;

    statementData.data = data;
    statementData.summary = summary;

    return statementData;
}

export function getStaffSOA(context) {
    const {
        accountid,
        currencies,
        exchangerates,
        fromts,
        tots,
        selectedsubaccountid,
        selectedcurrencyid,
    } = context;

    const statementData = { data: [], summary: {} };
    let data = [];

    const selectedcurrencysymbol = currencies.find((currency) => currency.id === selectedcurrencyid)?.symbol;

    const generalledgerdata = getGeneralLedgerData(context);
    let filtereddata = generalledgerdata
        .filter(data => data.accounttype == 'staff')
        .filter(data => data.accountid == accountid)
        .filter(data => data.ts >= fromts && data.ts <= tots)

    let balance = 0;
    filtereddata.forEach((entry) => {
        const date = moment.unix(entry.ts).format('D/MMM/YYYY')
        let debit = parseFloat(entry.debit) || 0;
        let credit = parseFloat(entry.credit) || 0;

        if (entry.currencyid !== selectedcurrencyid) {
            const NearestExchangeRate = findNearestExchangeRate(exchangerates, entry.ts, entry.currencyid, selectedcurrencyid);
            const exchangerate = NearestExchangeRate.exchangerate;

            debit = debit * exchangerate;
            credit = credit * exchangerate;
        }

        balance = balance - debit + credit;

        data.push({
            id: entry.id,
            type: entry.type,
            date: date,
            name: entry.name,
            debit: debit,
            debitcurrency: selectedcurrencysymbol,
            credit: credit,
            creditcurrency: selectedcurrencysymbol,
            balance: balance,
            balancecurrency: selectedcurrencysymbol,
        })
    });

    let summary = { currency: '', totalcredit: 0, totaldebit: 0, total: 0 };
    summary = getsummary(data, currencies, exchangerates, selectedcurrencyid)

    statementData.data = data;
    statementData.summary = summary;

    return statementData;
}

export function getEquityAccountSOA(context) {
    const {
        accountid,
        currencies,
        exchangerates,
        fromts,
        tots,
        selectedsubaccountid,
        selectedcurrencyid,
    } = context;

    const statementData = { data: [], summary: {} };
    let data = [];

    const selectedcurrencysymbol = currencies.find((currency) => currency.id === selectedcurrencyid)?.symbol;

    const generalledgerdata = getGeneralLedgerData(context);
    let filtereddata = generalledgerdata
        .filter(data => data.accounttype == 'equityaccounts')
        .filter(data => data.accountid == accountid)
        .filter(data => data.ts >= fromts && data.ts <= tots)

    let balance = 0;
    filtereddata.forEach((entry) => {
        const date = moment.unix(entry.ts).format('D/MMM/YYYY')
        let debit = parseFloat(entry.debit) || 0;
        let credit = parseFloat(entry.credit) || 0;

        if (entry.currencyid !== selectedcurrencyid) {
            const NearestExchangeRate = findNearestExchangeRate(exchangerates, entry.ts, entry.currencyid, selectedcurrencyid);
            const exchangerate = NearestExchangeRate.exchangerate;

            debit = debit * exchangerate;
            credit = credit * exchangerate;
        }

        balance = balance - debit + credit

        data.push({
            id: entry.id,
            type: entry.type,
            date: date,
            name: entry.name,
            debit: debit,
            debitcurrency: selectedcurrencysymbol,
            credit: credit,
            creditcurrency: selectedcurrencysymbol,
            balance: balance,
            balancecurrency: selectedcurrencysymbol,
        })
    });

    let summary = { currency: '', totalcredit: 0, totaldebit: 0, total: 0 };
    summary = getsummary(data, currencies, exchangerates, selectedcurrencyid)

    statementData.data = data;
    statementData.summary = summary;

    return statementData;
}

export function getAssetAccountSOA(context) {
    const {
        accountid,
        currencies,
        exchangerates,
        fromts,
        tots,
        selectedsubaccountid,
        selectedcurrencyid,
    } = context;

    const statementData = { data: [], summary: {} };
    let data = [];

    const selectedcurrencysymbol = currencies.find((currency) => currency.id === selectedcurrencyid)?.symbol;

    const generalledgerdata = getGeneralLedgerData(context);
    let filtereddata = generalledgerdata
        .filter(data => data.accounttype == 'assetaccounts')
        .filter(data => data.accountid == accountid)
        .filter(data => data.ts >= fromts && data.ts <= tots)

    let balance = 0;
    filtereddata.forEach((entry) => {
        const date = moment.unix(entry.ts).format('D/MMM/YYYY')
        let debit = parseFloat(entry.debit) || 0;
        let credit = parseFloat(entry.credit) || 0;

        if (entry.currencyid !== selectedcurrencyid) {
            const NearestExchangeRate = findNearestExchangeRate(exchangerates, entry.ts, entry.currencyid, selectedcurrencyid);
            const exchangerate = NearestExchangeRate.exchangerate;

            debit = debit * exchangerate;
            credit = credit * exchangerate;
        }

        balance = balance - debit + credit

        data.push({
            id: entry.id,
            type: entry.type,
            date: date,
            name: entry.name,
            debit: debit,
            debitcurrency: selectedcurrencysymbol,
            credit: credit,
            creditcurrency: selectedcurrencysymbol,
            balance: balance,
            balancecurrency: selectedcurrencysymbol,
        })
    });

    let summary = { currency: '', totalcredit: 0, totaldebit: 0, total: 0 };
    summary = getsummary(data, currencies, exchangerates, selectedcurrencyid)

    statementData.data = data;
    statementData.summary = summary;

    return statementData;
}